import React from 'react';
import { NavLink, useParams} from 'react-router-dom';
import Header from './../Common/Header';
import Footer from './../Common/Footer';
import LatestBlogs2 from '../Elements/LatestBlogs2';
import BlogComments from '../Elements/BlogComments';
import Banner from './../Elements/Banner';
import { blogs } from './../../assets/js/blogData';

var bnrimg = require('./../../images/banner/7.jpg');

const PostImage = () => {
    const { blogId } = useParams();  // Użycie hooka useParams do pobrania parametru
    const blog = blogs.find(p => p.index.toString() === blogId);  
        return (
            <>

                <Header />
                <div className="page-content ">
                <Banner title="Putting a plan to action, to assure your satisfaction!." pagename="Post Image" bgimage={bnrimg}/>
                    
                    {/* SECTION CONTENT START */}
                    <div className="section-full p-tb80 inner-page-padding">
                        <div className="container">
                        <div className="blog-single-wrap-width">
                            <div className="blog-post date-style-3 blog-detail text-black">
                                <div className="mt-post-media clearfix m-b30">
                                    <ul className="grid-post">
                                        <li>
                                            <div className="portfolio-item">
                                                <img className="img-responsive" src={blog.image} alt="" />
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                                <div className="mt-post-meta ">
                                    <ul>
                                        <li className="post-date"><strong></strong> <span>{blog.date}</span> </li>
                                        <li className="post-author"><NavLink to={"#"}>Autor: <span>{blog.author}</span></NavLink> </li>
                                        <li className="post-category"><NavLink to={"#"}><span>{blog.category}</span></NavLink> </li>
                                    </ul>
                                </div>
                                <div className="mt-post-title ">
                                    <h3 className="post-title"><NavLink to={"#"} className="font-weight-600">{blog.title}</NavLink></h3>
                                </div>
                                <div className="mt-post-text">   {blog.description.split('\n').filter(paragraph => paragraph.trim().length > 0).map((paragraph, index) => (
                                            <p key={index}>{paragraph}</p>
                                        ))} <blockquote className="bg-dark text-white author-quote">
                                        <h4 className="m-b0">{blog.wordsOfwisdom}<i className="fa fa-quote-right" /> </h4>
                                        <div className="p-t15  text-white">
                                            <strong className="text-primary">{blog.wowAuthor}</strong>
                                            
                                        </div>
                                    </blockquote>
                                    <p> {blog.overGaleryText} </p>
                                    <div className="row">{blog.blogGalery.map((img, index) => (
                                    
                                        <div key={index} className="col-md-4 col-sm-4">
                                            <div className="mt-box m-b30">
                                                <div className="mt-media">
                                                    <img src={img} alt="" />
                                                </div>
                                            </div>
                                        </div>
                                    
                                       
                                    ))}</div>
                                
                                    <p>{blog.underGeleryText}</p>
                                </div>
                                <div className="autor-post-tag-share bdr-t-1 bdr-solid bdr-gray p-t20">
                                    <div className="row">
                                        <div className="col-md-6 col-sm-6">
                                            <div className="widget widget_tag_cloud">
                                                <h4 className="tagcloud">Tags</h4>
                                                <div className="tagcloud">
                                                    <NavLink to={"#"}>First tag</NavLink>&nbsp;
                                                    <NavLink to={"#"}>Second tag</NavLink>&nbsp; 
                                                    <NavLink to={"#"}>Three tag</NavLink>&nbsp; 
                                                    <NavLink to={"#"}>Four tag</NavLink>&nbsp; 
                                                    <NavLink to={"#"}>Five tag</NavLink> 
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6 col-sm-6">
                                            <div className="mt-box">
                                                <div className="clearfix">
                                                    <h4>Share this Post:</h4>
                                                    <div className="widget_social_inks">
                                                        <ul className="social-icons social-md social-square social-dark m-b0">
                                                            <li><NavLink to={"#"} className="fa fa-facebook" /></li>
                                                            <li><NavLink to={"#"} className="fa fa-twitter" /></li>
                                                            <li><NavLink to={"#"} className="fa fa-rss" /></li>
                                                            <li><NavLink to={"#"} className="fa fa-youtube" /></li>
                                                            <li><NavLink to={"#"} className="fa fa-instagram" /></li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <LatestBlogs2 bgcolor="bg-gray"/>
                            <BlogComments/>
                        </div>
                        </div>
                    </div>
                    {/* SECTION CONTENT END */}
                </div>


                <Footer />

            </>
        );
    
};

export default PostImage;